export const guideLeft = (parentLevel) => (parentLevel <= 1 ? 19 : 36 + (parentLevel - 2) * 14 + 5);

const textLeft = (level) => (level <= 1 ? 10 : 36 + (level - 2) * 14);

export const navButtonSx = (theme, { level, collapsed, kind }) => {
  const c = theme.palette.custom;
  const sub = level > 1;

  let selected;
  if (kind === 'group') {
    selected = {
      backgroundColor: collapsed ? c.panel : 'transparent',
      boxShadow: collapsed ? c.shadows.active : 'none',
      color: theme.palette.text.primary,
      '& .MuiListItemIcon-root': { color: theme.palette.primary.main },
      '&:hover': { backgroundColor: collapsed ? c.panel : c.hover }
    };
  } else if (sub) {
    selected = {
      backgroundColor: 'transparent',
      color: c.primaryText,
      '& .MuiListItemIcon-root': { color: theme.palette.primary.main },
      '&:hover': { backgroundColor: c.hover }
    };
  } else {
    selected = {
      backgroundColor: c.panel,
      boxShadow: c.shadows.active,
      color: theme.palette.text.primary,
      '& .MuiListItemIcon-root': { color: theme.palette.primary.main },
      '&:hover': { backgroundColor: c.panel }
    };
  }

  return {
    position: 'relative',
    borderRadius: '10px',
    mb: '2px',
    minHeight: sub ? 34 : 40,
    py: sub ? '6px' : '8px',
    pl: collapsed ? 0 : `${textLeft(level)}px`,
    pr: collapsed ? 0 : '10px',
    justifyContent: collapsed ? 'center' : 'flex-start',
    alignItems: 'center',
    color: theme.palette.text.secondary,
    transition: 'background-color .15s ease, color .15s ease, box-shadow .15s ease',
    '& .MuiListItemIcon-root': { color: theme.palette.text.disabled },
    '&:hover': {
      backgroundColor: c.hover,
      color: theme.palette.text.primary,
      '& .MuiListItemIcon-root': { color: theme.palette.text.primary }
    },
    '&.Mui-selected': selected,
    '&.Mui-focusVisible': { boxShadow: `inset 0 0 0 2px ${theme.palette.primary[200]}` }
  };
};

export const navIconSx = ({ level, collapsed }) =>
  level > 1
    ? {
        position: 'absolute',
        left: `${guideLeft(level - 1) - 4}px`,
        width: 8,
        minWidth: 0,
        display: 'flex',
        justifyContent: 'center'
      }
    : {
        minWidth: collapsed ? 0 : 30,
        my: 0,
        display: 'flex',
        justifyContent: collapsed ? 'center' : 'flex-start'
      };

export const navTextSx = { my: 0, minWidth: 0 };

export const navLabelSx = (level, selected) => ({
  fontSize: level > 1 ? '0.84375rem' : '0.875rem',
  fontWeight: selected ? 600 : 500,
  lineHeight: 1.4,
  color: 'inherit',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});